var _desc, _style, _circle, _ellipse, _rect, _circle2, _line, _line2, _line3, _line4, _line5, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptySearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 200",
    width: 240,
    height: 200,
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "empty-search-title"
  }, "Ei l\xF6ytynyt mit\xE4\xE4n") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "empty-search-title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "empty-search-desc"
  }, "Suurennuslasi tutkii tyhj\xE4\xE4 korttia")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .empty-search-accent { fill: var(--empty-accent, #6366f1); }\n    .empty-search-stroke { stroke: var(--empty-accent, #6366f1); }\n    .empty-search-muted  { fill: var(--empty-muted, #e0e7ff); }\n    .empty-search-surface{ fill: var(--empty-surface, #ffffff); }\n    .empty-search-line   { stroke: var(--empty-line, #c7d2fe); }\n    .empty-search-search { animation: empty-search-search 5s ease-in-out 2; }\n    @keyframes empty-search-search { 0%,100% { transform: translate(0,0); } 30% { transform: translate(-10px,-6px); } 65% { transform: translate(6px,-12px); } }\n    @media (prefers-reduced-motion: reduce) { .empty-search-search { animation: none; } }\n  ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 104,
    r: 84,
    className: "empty-search-muted",
    opacity: 0.55
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 172,
    rx: 56,
    ry: 6,
    className: "empty-search-accent",
    opacity: 0.12
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 42,
    width: 104,
    height: 124,
    rx: 10,
    className: "empty-search-surface empty-search-stroke",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 64,
    r: 8,
    className: "empty-search-muted"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 94,
    y1: 60,
    x2: 140,
    y2: 60,
    className: "empty-search-line",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 94,
    y1: 70,
    x2: 124,
    y2: 70,
    className: "empty-search-line",
    strokeWidth: 4,
    strokeLinecap: "round",
    opacity: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 72,
    y1: 92,
    x2: 148,
    y2: 92,
    className: "empty-search-line",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeDasharray: "2 8",
    opacity: 0.7
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 72,
    y1: 106,
    x2: 136,
    y2: 106,
    className: "empty-search-line",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeDasharray: "2 8",
    opacity: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 72,
    y1: 120,
    x2: 142,
    y2: 120,
    className: "empty-search-line",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeDasharray: "2 8",
    opacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "empty-search-search"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 172,
    y1: 142,
    x2: 194,
    y2: 164,
    className: "empty-search-stroke",
    strokeWidth: 11,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 122,
    r: 28,
    className: "empty-search-surface empty-search-stroke",
    strokeWidth: 6,
    fillOpacity: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 112 a18 18 0 0 1 14 -10",
    fill: "none",
    className: "empty-search-line",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143,
    cy: 126,
    r: 2.6,
    className: "empty-search-accent",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 126,
    r: 2.6,
    className: "empty-search-accent",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 126,
    r: 2.6,
    className: "empty-search-accent",
    opacity: 0.45
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearch);
export default __webpack_public_path__ + "static/media/empty-search.534689e466a5267cef19a230428abe8c.svg";
export { ForwardRef as ReactComponent };